import Container from "@components/common/Container";
import MinimalFooter from "@components/common/MinimalFooter";
import NavBarLogo from "@components/common/NavBar/NavBarLogo";
import { Button } from "@justhome/react-ui";
import { useApplicationTranslation } from "@lib/hooks/translations";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
import ApplicationHeaderNav from "./ApplicationHeaderNav";
import Fade from "./Fade";
import ProgressBarHeader from "./ProgressBarHeader";

interface SplitLayoutBodyProps extends PropsWithChildren {
  className?: string;
  innerContainerClassName?: string;
  state: any;
  currentStepNumber: number;
  numberOfSteps: number;
}

const SplitLayoutBody: FC<SplitLayoutBodyProps> = ({
  children,
  className,
  innerContainerClassName = "max-w-[742px] w-full",
  state = 1,
  currentStepNumber,
  numberOfSteps,
}) => {
  const { partner } = usePartnerContext();
  return (
    <div className="grow flex flex-col">
      <Container fullWidth padding className="flex justify-end py-3xs">
        <NavBarLogo href="/" className="m:hidden mr-auto" partner={partner} />
        <ApplicationHeaderNav />
      </Container>
      <Container fullWidth padding className="m:hidden">
        <ProgressBarHeader
          currentStepNumber={currentStepNumber}
          numberOfSteps={numberOfSteps}
        />
      </Container>
      <Container
        fullWidth
        padding
        className={clsx(
          "flex m:items-center justify-center grow py-m",
          className,
        )}
      >
        <div className={innerContainerClassName}>
          <Fade state={state}>{children}</Fade>
        </div>
      </Container>
      <MinimalFooter isFullWidth isPartner={!!partner} />
    </div>
  );
};

const SplitLayoutAside = ({ children }: any) => {
  return <div className="hidden m:flex w-[440px]">{children}</div>;
};

const SplitLayoutMobileFooter: FC<
  PropsWithChildren<{ onPrevious: () => void }>
> = ({ children, onPrevious }) => {
  const { t } = useApplicationTranslation();

  return (
    <div className="fixed bottom-none left-none right-none m:hidden py-2xs px-s flex justify-between bg-neutral-0 border-t border-neutral-25">
      <Button
        onClick={() => onPrevious()}
        variant="ghost"
        size="md"
        iconStart="Left"
        paddingX
      >
        {t("link_back_previous")}
      </Button>
      {children}
    </div>
  );
};

const SplitLayout: FC<PropsWithChildren> = ({ children }: any) => {
  return <div className="flex min-h-screen">{children}</div>;
};

export default Object.assign(SplitLayout, {
  Aside: SplitLayoutAside,
  Body: SplitLayoutBody,
  MobileFooter: SplitLayoutMobileFooter,
});
